import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue";
var _hoisted_1 = {
  class: "side-modal-news-button"
};
var _hoisted_2 = {
  class: "side-modal-news-button-icon"
};
var _hoisted_3 = {
  key: 0,
  class: "side-modal-news-button-text"
};
var _hoisted_4 = ["href"];
var _hoisted_5 = {
  class: "side-modal-news-button"
};
var _hoisted_6 = {
  class: "side-modal-news-button-icon"
};
var _hoisted_7 = {
  key: 0,
  class: "side-modal-news-button-text"
};
var _hoisted_8 = {
  class: "side-modal-news-button-icon"
};
var _hoisted_9 = {
  key: 0,
  class: "side-modal-news-button-text"
};
var _hoisted_10 = {
  key: 3,
  class: "sideModalDropdown"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_v_video_side_modal = _resolveComponent("v-video-side-modal");
  return _openBlock(), _createElementBlock("div", null, [$props.videoUrl ? (_openBlock(), _createElementBlock("a", {
    key: 0,
    class: "side-modal-news-button-wrapper",
    href: "#",
    onClick: _cache[0] || (_cache[0] = _withModifiers(function ($event) {
      return $options.setVideoUrl($props.videoUrl);
    }, ["prevent"]))
  }, [_createElementVNode("button", _hoisted_1, [_createElementVNode("span", _hoisted_2, [_renderSlot(_ctx.$slots, "icon", {}, undefined, true)]), $props.text ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString($props.text), 1 /* TEXT */)) : _createCommentVNode("v-if", true)])])) : $props.link ? (_openBlock(), _createElementBlock("a", {
    key: 1,
    class: "side-modal-news-button-wrapper",
    href: $props.link
  }, [_createElementVNode("button", _hoisted_5, [_createElementVNode("span", _hoisted_6, [_renderSlot(_ctx.$slots, "icon", {}, undefined, true)]), $props.text ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString($props.text), 1 /* TEXT */)) : _createCommentVNode("v-if", true)])], 8 /* PROPS */, _hoisted_4)) : (_openBlock(), _createElementBlock("a", {
    key: 2,
    class: "side-modal-news-button",
    onClick: _cache[1] || (_cache[1] = function () {
      return $options.toggleDropdown && $options.toggleDropdown.apply($options, arguments);
    })
  }, [_createElementVNode("span", _hoisted_8, [_renderSlot(_ctx.$slots, "icon", {}, undefined, true)]), $props.text ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString($props.text), 1 /* TEXT */)) : _createCommentVNode("v-if", true)])), _createCommentVNode(" Dropdown content "), $data.isDropdownVisible ? (_openBlock(), _createElementBlock("div", _hoisted_10, [$props.locale === 'cs-CZ' ? (_openBlock(), _createElementBlock("button", {
    key: 0,
    class: "dropdown-button",
    onClick: _cache[2] || (_cache[2] = function ($event) {
      return $options.setVideoUrl('https://www.youtube.com/embed/hbSiCNRnSMY?si=0xfoca3tY2-Pa2Ky');
    })
  }, "Propočet sazeb a metodický filtr")) : (_openBlock(), _createElementBlock("button", {
    key: 1,
    class: "dropdown-button",
    onClick: _cache[3] || (_cache[3] = function ($event) {
      return $options.setVideoUrl('https://www.youtube.com/embed/4m3q3iJNpo8?si=c_3xhBbGALwXhTix');
    })
  }, "Prepočet sadzieb a metodický filter")), $props.locale === 'cs-CZ' ? (_openBlock(), _createElementBlock("button", {
    key: 2,
    class: "dropdown-button",
    onClick: _cache[4] || (_cache[4] = function ($event) {
      return $options.setVideoUrl('https://www.youtube.com/embed/3y3weNaE-wI');
    })
  }, "Propočet bonity")) : (_openBlock(), _createElementBlock("button", {
    key: 3,
    class: "dropdown-button",
    onClick: _cache[5] || (_cache[5] = function ($event) {
      return $options.setVideoUrl('https://www.youtube.com/embed/K7qY_HXknvo?si=q4cXY3ERBr-ePMTR');
    })
  }, "Prepočet bonity")), $props.locale === 'cs-CZ' ? (_openBlock(), _createElementBlock("button", {
    key: 4,
    class: "dropdown-button",
    onClick: _cache[6] || (_cache[6] = function ($event) {
      return $options.setVideoUrl('https://www.youtube.com/embed/1sBu2ytMglg');
    })
  }, "Sloupcové zobrazení nabídek")) : (_openBlock(), _createElementBlock("button", {
    key: 5,
    class: "dropdown-button",
    onClick: _cache[7] || (_cache[7] = function ($event) {
      return $options.setVideoUrl('https://www.youtube.com/embed/_5bVQ03yKAk');
    })
  }, "Stĺpcové zobrazenie ponúk")), $props.locale === 'cs-CZ' ? (_openBlock(), _createElementBlock("button", {
    key: 6,
    class: "dropdown-button",
    onClick: _cache[8] || (_cache[8] = function ($event) {
      return $options.setVideoUrl('https://www.youtube.com/embed/4tHHmoWHSok?si=5c66zZSy-CI3Mecu');
    })
  }, "Metodika")) : _createCommentVNode("v-if", true)])) : _createCommentVNode("v-if", true), _createVNode(_component_v_video_side_modal, {
    videoSideModalUrl: $data.internalVideoUrl,
    ref: "videoSideModal",
    class: "video-side-modal",
    onModalHidden: $options.onModalHidden
  }, null, 8 /* PROPS */, ["videoSideModalUrl", "onModalHidden"])]);
}